<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template v-slot:item.topMenuIco="{ item }">
      <img v-if="item.topMenuIco" :src="item.topMenuIco" class="category-top-menu-icon" />
    </template>
  </entity-list-table>
</template>

<script>

  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import { mapGetters } from 'vuex'
  import CategoryDataService from '@/services/api/CategoryDataService'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Категории',
        dataService: CategoryDataService,
        createRouteName: 'categoryCreate',
        editRouteName: 'categoryEdit',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Иконка в меню', value: 'topMenuIco', align: 'center' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Slug', value: 'slug', align: 'start' },
          { text: 'Индекс сортировки', value: 'sortOrder', align: 'center' },
          { text: 'Только для CRM', value: 'onlyCrm', align: 'center', type: 'boolean-check' },
        ],

        allowDelete: true,
        showStatusColumn: true,
      }
    },
    computed: {
      ...mapGetters({
        getTimezoneTitle: 'app/getTimezoneTitle',
      }),
    },
  }
</script>
<style lang="less" scoped>
.category-top-menu-icon {
  max-height: 60px;
}
</style>
